import React from 'react';
import { cx } from '@/utils';
import Lottie from 'lottie-react';

import loadingLottie from './LOADING_SEDE_ELECTRONICA.json';

export const Splash = ({ className }: { className?: string }) => {
  return (
    <div
      className={cx(
        'z-toast fixed left-0 top-0 flex h-full w-[100dvw] flex-col items-center justify-center bg-white transition-all !duration-500',
        className
      )}
    >
      <style jsx>{`
        @keyframes dotPulse {
          0%,
          80%,
          100% {
            opacity: 0.3;
          }
          40% {
            opacity: 1;
          }
        }
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .dot-1 {
          animation: dotPulse 1.4s infinite ease-in-out;
          animation-delay: 0s;
        }
        .dot-2 {
          animation: dotPulse 1.4s infinite ease-in-out;
          animation-delay: 0.2s;
        }
        .dot-3 {
          animation: dotPulse 1.4s infinite ease-in-out;
          animation-delay: 0.4s;
        }
        .text-animate {
          animation: fadeInUp 0.8s ease-out 0.5s both;
        }
      `}</style>
      {/* <img
        src="/splash.gif"
        alt="Loading..."
        className="h-96 w-[600px]"
        // style={{ animationDuration: '8s' }}
      /> */}
      <Lottie
        className="outline-none"
        animationData={loadingLottie}
        loop
        style={{ width: 500, height: 300, padding: 0 }}
      />
      <div className="text-animate -mt-10 flex items-center justify-center">
        <span className="text-lg font-medium text-gray-500">Cargando sede electrónica</span>
        <div className="ml-1 flex">
          <span className="dot-1 text-lg text-gray-500">.</span>
          <span className="dot-2 text-lg text-gray-500">.</span>
          <span className="dot-3 text-lg text-gray-500">.</span>
        </div>
      </div>
    </div>
  );
};

// const CasteAnimation = ({ className }: { className?: string }) => {
//   return (
//     <div
//       className={cx(
//         'fixed left-0 top-0 z-[99999999] flex h-full w-[100dvw] items-center justify-center bg-white transition-all !duration-500',
//         className
//       )}
//     >
//       <Lottie
//         animationData={animationData}
//         loop={true}
//         autoplay={true}
//         className="h-96 w-[600px]"
//       />
//     </div>
//   );
// };
